import { render } from "./Header.vue?vue&type=template&id=db5481c6&scoped=true&lang=pug"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=db5481c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db5481c6"

export default script